/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/KeesingGames/theme';

export const KeesingGamesTheme = theme;
